import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useData } from "@/lib/data";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Eraser } from "lucide-react";
import { toast } from "sonner";

const LABELS = { cuttings: "Kesim", orders: "Sipariş", shipments: "Sevkiyat" };

export const LegacyCleanup = () => {
  const data = useData();
  const [counts, setCounts] = useState(null);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/maintenance/legacy").then((r) => setCounts(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const total = counts ? Object.values(counts).reduce((a, b) => a + b, 0) : 0;

  const run = async () => {
    setBusy(true);
    try {
      const r = await api.post("/maintenance/legacy/cleanup");
      const n = Object.values(r.data.deleted).reduce((a, b) => a + b, 0);
      toast.success(`${n} eski kayıt temizlendi`);
      await load();
      await Promise.all(Object.keys(data).filter((k) => k.startsWith("refresh")).map((k) => data[k]?.()));
    } catch (e) {
      toast.error(e.response?.data?.detail || "Temizlik başarısız");
    } finally { setBusy(false); }
  };

  return (
    <section className="mt-5 rounded-lg border border-[#DCCFB8] bg-[#FFFBF4] p-6" data-testid="legacy-cleanup-card">
      <h2 className="font-display text-xl font-bold uppercase tracking-tight mb-2 flex items-center gap-2">
        <Eraser className="w-5 h-5 text-[#B45309]" /> Eski Kayıt Temizliği
      </h2>
      <p className="text-sm text-[#6B5B4A] mb-4">İlk sürümden kalan, eksik bilgili ve listelerde görünmeyen kayıtlar. Silmeden önce otomatik güvenlik yedeği alınır; kesim/sevkiyatın stoğa etkisi geri alınır.</p>
      <div className="grid grid-cols-3 gap-2 mb-4">
        {Object.entries(LABELS).map(([k, l]) => (
          <div key={k} className="rounded border border-[#DCCFB8] px-3 py-2">
            <p className="text-[10px] font-mono uppercase text-[#6B5B4A]">{l}</p>
            <p className="font-mono font-bold" data-testid={`legacy-count-${k}`}>{counts ? counts[k] : "…"}</p>
          </div>
        ))}
      </div>
      <Button onClick={() => setOpen(true)} disabled={!total || busy} data-testid="legacy-cleanup-btn"
        className="h-11 bg-[#D97706] hover:bg-[#B45309] text-white font-display uppercase tracking-wide">
        {busy ? "Temizleniyor..." : total ? `${total} Eski Kaydı Temizle` : "Eski kayıt yok"}
      </Button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent className="bg-[#FFFBF4] border-[#DCCFB8]" data-testid="legacy-confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Eski kayıtlar silinsin mi?</AlertDialogTitle>
            <AlertDialogDescription>
              {Object.entries(LABELS).map(([k, l]) => `${l}: ${counts?.[k] || 0}`).join(" · ")} kayıt kalıcı olarak silinecek ve stok etkileri geri alınacak. Önce güvenlik yedeği alınır.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="legacy-confirm-cancel">Vazgeç</AlertDialogCancel>
            <AlertDialogAction onClick={run} data-testid="legacy-confirm-ok" className="bg-[#EF4444] hover:bg-[#B91C1C] text-white">
              Evet, temizle
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </section>
  );
};
